module.exports = "<ul id=\"translates\" class=\"list-inline\">\n    <li\n        ng-repeat=\"key in translates.languages\"\n        ng-click=\"translates.changeLanguage(key)\"\n        ng-bind=\"key\">\n    </li>\n</ul>"


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/translates/translates.html
 ** module id = 233
 ** module chunks = 0
 **/